import React, { Fragment } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@context/auth-context";
import { UserType } from "@models/User";

interface ProtectedRouteProps {
    allowedRoles: UserType[];
    children: React.ReactNode;
}

const ProtectedPage: React.FC<ProtectedRouteProps> = ({ allowedRoles, children }) => {
    const { authState } = useAuth();
    const { user } = authState;

    if (!user || !allowedRoles.includes(user.userType)) {
        return <Navigate to="/unauthorised" replace />;
    }

    return <>{children}</>;
};

export default ProtectedPage;
